import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import i18n from "../../i18n/i18n";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
  "Content-Type": "application/json",
  Lang: i18n.language,
});

const buildMovementsParams = ({
  page = 1,
  activity = [],
  date_filter = "",
  date_from = "",
  date_to = "",
} = {}) => {
  const params = { page };

  if (Array.isArray(activity)) {
    let i = 0;
    activity.forEach((code) => {
      if (code == null || String(code).trim() === "") return;
      params[`activity[${i}]`] = String(code);
      i += 1;
    });
  }

  if (date_filter) params.date_filter = date_filter;

  if (date_filter === "range") {
    if (date_from) params.date_from = date_from;
    if (date_to) params.date_to = date_to;
  }

  return params;
};

export const fetchTeamworkMovements = createAsyncThunk(
  "teamwork_movements/fetchAll",
  async (arg = {}, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/teamwork-movements`, {
        headers: authHeaders(),
        params: buildMovementsParams(arg),
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to load teamwork movements";
      return rejectWithValue(message);
    }
  }
);

export const fetchTeamworkActivities = createAsyncThunk(
  "teamwork_movements/fetchActivities",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/teamwork-movements/activities`,
        { headers: authHeaders() }
      );
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to load activities";
      return rejectWithValue(message);
    }
  }
);

const TeamworkMovementsSlice = createSlice({
  name: "teamwork_movements",
  initialState: {
    movements: [],
    activities: [],
    isLoading: false,
    activitiesLoading: false,
    error: null,
    activitiesError: null,
    pagination: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.activitiesError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeamworkMovements.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchTeamworkMovements.fulfilled, (state, action) => {
        state.isLoading = false;
        const root = action.payload?.data ?? action.payload;
        state.movements = Array.isArray(root?.data) ? root.data : [];
        state.pagination = root?.pagination || null;
      })
      .addCase(fetchTeamworkMovements.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load data";
        state.movements = [];
        state.pagination = null;
      })
      .addCase(fetchTeamworkActivities.pending, (state) => {
        state.activitiesLoading = true;
        state.activitiesError = null;
      })
      .addCase(fetchTeamworkActivities.fulfilled, (state, action) => {
        state.activitiesLoading = false;
        const data = action.payload?.data;
        state.activities = Array.isArray(data) ? data : [];
      })
      .addCase(fetchTeamworkActivities.rejected, (state, action) => {
        state.activitiesLoading = false;
        state.activitiesError = action.payload || "Failed to load activities";
        state.activities = [];
      });
  },
});

export const { clearState } = TeamworkMovementsSlice.actions;
export default TeamworkMovementsSlice.reducer;
